import { useAction, useAtom } from '@reatom/npm-react'
import { css } from 'styled-components'

import { selectedNetworkAtom } from '@root/entities/network'
import { AppDataTable } from '@root/features/app-data-table/app-data-table'
import { useAppRoutes } from '@root/features/routing'

import { DistributeTableEmpty } from './distribute-table-empty'

import type { DistributeRowVariant, DistributeTableModel } from '../../atoms'

type Props = {
  onClose: () => void
  model: DistributeTableModel
  rowVariant?: DistributeRowVariant
}

export const DistributeTable: React.FC<Props> = ({
  model,
  rowVariant = 'default',
  onClose,
}) => {
  const { navigateToTrading, navigateToRoot } = useAppRoutes()

  const refresh = useAction(model.tableModel.refresh)
  const load = useAction(model.tableModel.load)
  const [selectedNetwork] = useAtom(selectedNetworkAtom)

  const handleExploreTokens = () => {
    navigateToRoot()
    onClose()
  }

  return (
    <AppDataTable
      context={{ refresh: load }}
      css={css`
        height: 100%;
      `}
      model={model.tableModel}
      rowHeight={rowVariant === 'stacked' ? 80 : 50}
      onRowClick={(row) => {
        navigateToTrading(row.pair.address, selectedNetwork)
        onClose()
      }}
      renderEmptyMessage={() => (
        <DistributeTableEmpty onRetry={handleExploreTokens} intent="empty" />
      )}
      renderError={() => (
        <DistributeTableEmpty onRetry={refresh} intent="error" />
      )}
    />
  )
}
